function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5846",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 107",
    style: {
      fill: "#fff",
      stroke: "#f6b119"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5060",
    d: "M10.561 1.549 1.654.2A1.437 1.437 0 0 0 .5.512 1.449 1.449 0 0 0 0 1.6v17.076a.813.813 0 0 0 .811.811h2.634v-4.255a1.415 1.415 0 0 1 1.418-1.418H6.89a1.415 1.415 0 0 1 1.418 1.418v4.255h3.445V2.952a1.419 1.419 0 0 0-1.192-1.4zm-6.1 10.44H3.242a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432H3.242a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432H3.242a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432H3.242a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm4.053 7.295H7.295a.608.608 0 0 1 0-1.216h1.216a.608.608 0 1 1 0 1.216zm0-2.432H7.295a.608.608 0 0 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432H7.295a.608.608 0 0 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432H7.295a.608.608 0 0 1 0-1.216h1.216a.608.608 0 1 1 0 1.216z",
    transform: "translate(22 21.822)",
    style: {
      fill: "#f6b119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5061",
    d: "M21.271 10.56 15.5 9.351v11.874h5.471a1.42 1.42 0 0 0 1.418-1.418v-7.861a1.412 1.412 0 0 0-1.118-1.386zm-1.921 8.233h-1.216a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432h-1.216a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216zm0-2.432h-1.216a.608.608 0 1 1 0-1.216h1.216a.608.608 0 0 1 0 1.216z",
    transform: "translate(19.064 20.084)",
    style: {
      fill: "#f6b119"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.ad49814eef269cba698b70384b1b6b4e.svg";
export { ForwardRef as ReactComponent };